export default {
    install: function (Vue, opts) {
        let users = {};
        users.loading = false;  // caricamento dell'oggetto
        users.data = [];        // l'elenco degli elementi
        users.page = 1;         // pagina corrente
        users.isEndList = false;    // indica se sono alla fine della lista
        users.isFirstList = true;   // indica se sono all'inizio della lista
        Vue.mixin({
            mounted() {
                /**
                 * Ritorna un singolo utente
                 * @param id
                 * @returns {Promise<unknown>}
                 */
                users.getSingle = (id) => {
                    return new Promise((resolve, reject) => {
                        users.loading = true;
                        let params = {};
                        this.api.get(`/users/${id}`, params, true)
                            .then((result) => {
                                if (result && result.success) {
                                    resolve(result.data);
                                }
                                reject(null);
                            })
                            .catch(() => {
                                reject(null);
                            })
                            .finally(() => {
                                users.loading = false;
                            });
                    });
                };
                /**
                 * Salvataggio
                 * @param data
                 * @param id
                 * @returns {Promise<unknown>}
                 */
                users.save = (data, id) => {
                    return new Promise((resolve, reject) => {
                        id = (id.toString().toLowerCase().trim() === 'new') ? null : id;
                        let call = null;
                        if (id == null) {
                            call = this.api.post(`/users`, data, false);
                        } else {
                            call = this.api.put(`/users/${id}`, data, false);
                        }
                        call.then((result) => {
                            if (result && result.success) {
                                resolve(true);
                            }
                            reject(null);
                        })
                            .catch((error) => {
                                reject(error);
                            });
                    });
                };
                users.delete = (id) => {
                    return new Promise((resolve, reject) => {
                        this.api.delete(`/users/${id}`, false).then((result) => {
                            if (result && result.success) {
                                resolve(true);
                            }
                            reject(null);
                        })
                            .catch((error) => {
                                reject(error);
                            });
                    });
                };
                /**
                 * Lista degli utenti
                 */
                users.getList = () => {
                    users.loading = true;
                    let params = {
                        page: users.page
                    };
                    this.api.get('/users', params, true)
                        .then((result) => {
                            users.data = [];
                            for (var key in result.data) {
                                users[key] = result.data[key];
                            }
                            users.isFirstList = true;
                            users.isEndList = false;
                            if (users.page !== 1) {
                                users.isFirstList = false;
                                users.isEndList = false;
                            }
                            if (users.page == users.pages) {
                                users.isEndList = true;
                                users.isFirstList = false;
                            }
                        })
                        .finally(() => {
                            users.loading = false;
                        });
                };
                /**
                 * Prende i dati della pagina successiva
                 */
                users.nextPage = () => {
                    if (users.page < users.pages) {
                        users.page = users.page + 1;
                        users.getList();
                    }
                };
                /**
                 * Prende i dati della pagina precendente
                 */
                users.prevPage = () => {
                    if (users.page > 1) {
                        users.page = users.page - 1;
                        users.getList();
                    }
                };
                /**
                 * Prende i dati della prima pagina
                 */
                users.firstPage = () => {
                    users.page = 1;
                    users.getList();
                };
                /**
                 * Prende i dati dell'ultima pagina
                 */
                users.lastPage = () => {
                    users.page = users.pages;
                    users.getList();
                };
                /**
                 * Prende i dati di una pagina prefissata
                 * @param page
                 */
                users.goPage = (page) => {
                    if (page > 0 && page <= users.pages) {
                        users.page = page;
                        users.getList();
                    }
                };
            }
        });
        Vue.prototype.api.users = users;
    }
}
